import {useState, useEffect} from 'react'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Button,
  Typography
} from '@material-ui/core'
import RichText from '../RichText'

export default function MakeSurveyWelcomeEmail (props) {
  const [emailBody, setEmailBody] = useState('')

  const onClose = () => {
    props.onClose()
  }
  const onAdd = () => {
    props.onClose({success: true, emailBody})
  }

  useEffect(() => {
    if (props.emailBody) {
      setEmailBody(props.emailBody)
    }
  }, [])

  return (
    <Dialog open={props.open} maxWidth={'xl'} aria-labelledby="Custom Welcome email">
      <DialogTitle>Customize your welcome email</DialogTitle>
      <DialogContent style={{minHeight: 300}}>
        <DialogContentText>
            {'Create a custom welcome email for when Survey links are sent to participants. This email will be sent for each survey interval.'}
        </DialogContentText>

        <Typography variant="body1">Email Body</Typography>
        <RichText className="richSurveyEmailEditor" body={emailBody} onChange={(newBody) => setEmailBody(newBody)} />

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Close</Button>
        <Button onClick={onAdd} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  )
}
